import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment } from 'react'
import { dialogPanel, cancelButton, confirmButton, title } from './styles'
import { ButtonAction, SubTitleText, TitleText } from 'pages/NotifyEvent/styles'
import { IconWarning } from 'components/NavBar/svg'

interface ModalWarningProps {
    isOpen: boolean
    handleConfirmModal: () => void
    handleCloseModal: () => void
}

const ModalWarning: React.FC<ModalWarningProps> = ({
    isOpen,
    handleConfirmModal,
    handleCloseModal
}) => {
    
    return (
        <div data-testid={'modal-warning'}>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog
                    as="div"
                    className="relative z-30"
                    onClose={handleCloseModal}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in dur   ation-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className={dialogPanel}>
                                    <div className='flex flex-col'>
                                        <div className='justify-center flex p-1'>
                                            <IconWarning></IconWarning>
                                        </div>
                                        <TitleText className={title}>
                                            Notificação não salva
                                        </TitleText>
                                        <div className='justify-center flex'>
                                            <SubTitleText >
                                                <p>
                                                Tem certeza  que deseja cancelar a notificação?
                                                </p>
                                                <p>
                                                Todos os dados serão apagados e não será possível recuperá-los.
                                                </p>         
                                            </SubTitleText>
                                        </div>
                                        <div className='justify-center flex gap-6'>
                                            <ButtonAction  
                                                    onClick={handleConfirmModal} 
                                                    className={confirmButton}>
                                                Continuar notificação
                                            </ButtonAction>
                                            <ButtonAction
                                                onClick={handleCloseModal}
                                                className={cancelButton}>
                                                Cancelar notificação
                                            </ButtonAction>
                                        </div>
                                        
                                    </div>                                    
                            
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </div>
    )
}

export { ModalWarning }
